import { render, staticRenderFns } from "./PartName.vue?vue&type=template&id=c09884be&scoped=true"
import script from "./PartName.vue?vue&type=script&lang=js"
export * from "./PartName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c09884be",
  null
  
)

export default component.exports